import React from 'react';
const bloques = [{
  icon: '🔴',
  title: 'BLOQUE 1 — 52 CURSOS PROFESIONALES',
  desc: 'Planeamiento (Superficial, Subterráneo, Diplomado) · Geología (Modelamiento 2D/3D, Simulación Geoestadística) · Geomecánica (Superficial, Subterránea, Estabilidad de Taludes) · Voladura (Perforación, JKSimblast, Shotplus, Iblast, Wipfrag) · Economía (Optimización de Pit, Evaluación Económica, Whittle) · Procesamiento (Minerales, Topografía, Ventilación) · Operaciones (Operación Minera, Muestreo + QA/QC)'
}, {
  icon: '💻',
  title: 'BLOQUE 2 — SOFTWARES PROFESIONALES INCLUIDOS',
  desc: 'Leapfrog · Vulcan · Deswik · Minesight · Datamine Studio · Whittle · AutoCAD · Civil 3D · ArcGIS · Rocscience · Ventsim · JKSimblast · Shotplus · MS Project · Topacal · Dips · Slide · Roclab · Talpac · Recmin · Mineplane · Phase6 · Swedge · FPC'
}, {
  icon: '📚',
  title: 'BLOQUE 3 — BIBLIOTECA TÉCNICA COMPLETA',
  desc: '+39 Manuales Cermin (los más buscados del sector) · +38 Libros de Ingeniería Minera · Estándares Operativos en Minería · SSOMA Completo (todos los formatos listos para usar)'
}, {
  icon: '🦺',
  title: 'BLOQUE 4 — CAPACITACIONES EN SEGURIDAD MINERA',
  desc: 'Trabajos en Altura · Espacios Confinados · Trabajos en Caliente · Manejo Defensivo · Auditorías de Seguridad · Salud Ocupacional · Primeros Auxilios · Seguridad con Explosivos · Rescate Minero · Sistema de Comando de Emergencias · Seguridad Eléctrica · Liderazgo y Motivación · Física aplicada a Ingenierías'
}];
export function CuadernillosDetail() {
  return <section className="pt-8 md:pt-10 pb-12 md:pb-20 px-4 bg-white" data-id="element-62">
      <div className="max-w-4xl mx-auto" data-id="element-63">
        <div className="text-center mb-8 md:mb-16" data-id="element-64">
          <h2 className="text-4xl font-black text-brand-dark mb-4" data-id="element-65">
            Lo que recibís
          </h2>
          <div className="inline-block bg-brand-blue text-white font-bold px-6 py-2 rounded-lg text-xl" data-id="element-66">
            ⛏️ MEGAPACK COMPLETO — 4 Bloques
          </div>
          <p className="text-xl text-gray-600 mt-4 font-medium" data-id="element-67">
            Para profesionales e ingenieros mineros en Argentina
          </p>
        </div>

        <div className="space-y-4 md:space-y-6" data-id="element-68">
          {bloques.map((b, i) => <div key={i} className="bg-white border-2 border-gray-100 p-4 md:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow flex flex-col md:flex-row gap-4 md:gap-6 items-start" data-id="element-69">
              <div className="text-5xl md:text-6xl flex-shrink-0" data-id="element-70">{b.icon}</div>
              <div data-id="element-71">
                <h3 className="text-2xl font-bold text-brand-dark mb-3" data-id="element-72">
                  {b.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed" data-id="element-73">
                  {b.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}